module.exports = __webpack_public_path__ + "35a52530c886ad786b40efd84c165f9f.svg";